// Traducciones en español para la política de privacidad
const privacy = {
  title: "Política de Privacidad de Zaquiel Cómic",
  lastUpdate: "Última actualización: 26/12/2024",
  intro:
    "En Zaquiel Cómic, nos comprometemos a proteger la privacidad de nuestros usuarios y a cumplir con el Reglamento General de Protección de Datos (RGPD). Esta política de privacidad detalla cómo recopilamos, usamos, almacenamos y protegemos tus datos personales. Al utilizar nuestro sitio web, aceptas los términos de esta política.",
  responsible: {
    title: "1. Responsable del tratamiento de los datos",
    description:
      "Nombre del responsable: Carlos Ortega Muñoz\nDirección: C. del Padre Julio Chevalier, 2, 47012 Valladolid\nCorreo electrónico de contacto: cortega27457@alumnos.uemc.es",
  },
  data: {
    title: "2. Datos personales recopilados",
    description:
      "Recopilamos los siguientes datos personales de forma anónima a través de nuestro formulario de opinión:",
    sex: "Sexo",
    age: "Edad",
    postalCode: "Código postal (CP)",
    readingPreferences: "Preferencias de lectura (digital o impreso)",
    habits: "Hábitos de lectura y opiniones sobre el cómic",
    monumentResponses:
      "Respuestas relacionadas con el monumento o lugar mencionado en el cómic",
    comments: "Comentarios adicionales (opcional)",
    noIdentification:
      "No recopilamos información que pueda identificarte directamente, como tu nombre, dirección de correo electrónico o dirección IP. Por este motivo, los datos almacenados no se pueden vincular a una persona específica.",
  },
  dataNotifications: {
    title: "2.1. Suscripción a notificaciones por correo",
    description:
      "Si eliges suscribirte a nuestras notificaciones por correo electrónico, recopilaremos y almacenaremos tu dirección de correo para informarte sobre nuevos capítulos y contenido. Estos datos se utilizan exclusivamente con fines de notificación y no se comparten con terceros.",
  },
  purpose: {
    title: "3. Finalidad del tratamiento",
    description:
      "Tus datos se recopilan y procesan para las siguientes finalidades:",
    analyze:
      "Analizar las opiniones de los lectores sobre el cómic y el lugar/monumento asociado.",
    improve: "Mejorar nuestro contenido y experiencias ofrecidas.",
    statistics: "Realizar estudios estadísticos de manera anónima.",
  },
  legalBasis: {
    title: "4. Base legal para el tratamiento",
    description:
      "El tratamiento de tus datos se realiza con base en tu consentimiento expreso, otorgado al aceptar nuestra política de privacidad al completar el formulario. Puedes retirar tu consentimiento en cualquier momento (consulta la Sección 8).",
  },
  storage: {
    title: "5. Período de almacenamiento",
    description:
      "Tus datos personales serán almacenados durante el tiempo necesario para cumplir con las finalidades descritas anteriormente. Una vez cumplidas, los datos serán anonimizados o eliminados periódicamente.",
  },
  recipients: {
    title: "6. Destinatarios de los datos",
    description:
      "Tus datos no serán compartidos con terceros, salvo:",
    legal: "En cumplimiento de una obligación legal.",
    rights: "Para proteger nuestros derechos legales o prevenir fraudes.",
  },
  security: {
    title: "7. Seguridad de los datos",
    description:
      "Aunque los datos recopilados son anónimos, implementamos medidas técnicas y organizativas adecuadas para protegerlos contra accesos no autorizados o usos indebidos, incluyendo:",
    https: "Comunicaciones seguras mediante HTTPS.",
    access: "Restricción de acceso a los datos a personal autorizado.",
    deletion: "Eliminación periódica de datos antiguos.",
  },
  rights: {
    title: "8. Derechos del usuario",
    description:
      "Tienes derecho a retirar tu consentimiento y a realizar consultas sobre el tratamiento de tus datos. Dado que los datos son anónimos, no es posible vincularlos a un individuo para eliminarlos.",
  },
  changes: {
    title: "9. Cambios en la política de privacidad",
    description:
      "Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Te notificaremos sobre cambios significativos mediante un aviso en nuestra página web.",
  },
  complaints: {
    title: "10. Reclamos ante la autoridad competente",
    description:
      "Si consideras que el tratamiento de tus datos no cumple con la normativa, tienes derecho a presentar un reclamo ante la Agencia Española de Protección de Datos (AEPD) o la autoridad correspondiente en tu país.",
    link: "Enlace a la AEPD: https://www.aepd.es",
  },
}; 

export default privacy; 